import { HubCardData } from '@/hooks/insights-hub/types';

/**
 * Removes alerts with the specified UUIDs from the given list of alerts.
 * @param {HubCardData[]} alerts
 * @param {string[]} alertUUIDsToRemove
 * @return {HubCardData[]}
 */
export const filterOutAlertsByUUID = (
  alerts: HubCardData[],
  alertUUIDsToRemove: string[],
): HubCardData[] =>
  alerts.filter((alert) => !alertUUIDsToRemove.includes(alert.alert_uuid));

/**
 * Updates the cache for the given query by removing alerts with the specified UUIDs.
 * @param {string[]} dataJson
 * @return {HubCardData[]}
 */
export const parseCardDataJson = (dataJson: string[]): HubCardData[] =>
  dataJson.map((cd) => JSON.parse(cd));

/**
 * Stringifies the card data for the given list of alerts, so it can be stored in the apollo cache.
 * @param {HubCardData[]} cards
 * @return {string[]}
 */
export const stringifyCardData = (cards: HubCardData[]): string[] =>
  cards.map((cd) => JSON.stringify(cd));
